var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-button-wrapper"},[_c('BaseButton',{staticClass:"rounded filter-button",attrs:{"icon-file":"map-pin-dark","icon-size":20},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.$t('swaplist_button_map_view')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }